import * as React from 'react'

import { CameraIcon } from 'lucide-react'
import { computed, makeObservable, observable, runInAction } from 'mobx'
import { inject, observer } from 'mobx-react'

import CommonThread from '~/client/src/shared/components/CommonThread/CommonThread'
import Message from '~/client/src/shared/models/Message'
import Photo from '~/client/src/shared/models/Photo'
import MessagesStore from '~/client/src/shared/stores/domain/MessagesStore/Messages.store'

interface IProps {
  photo: Photo
  showImages?: boolean
  hideThreadIfNoMessages?: boolean
  showFooterLine?: boolean
  messagesStore?: MessagesStore
  FileInputType
}

@inject('messagesStore')
@observer
class CommentsList extends React.Component<IProps> {
  @observable private localProps: IProps = null

  public constructor(props: IProps) {
    super(props)
    this.localProps = props
    makeObservable(this)
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps !== this.props) {
      runInAction(() => {
        this.localProps = this.props
      })
    }
  }

  @computed
  private get messages(): Message[] {
    const { photo, messagesStore } = this.localProps
    const photoMessage = messagesStore.list.find(
      message => message.photoId === photo.id,
    )

    if (!photoMessage) {
      return []
    }

    return messagesStore.list.filter(m => m.threadId === photoMessage.threadId)
  }

  private get hideThread(): boolean {
    const { hideThreadIfNoMessages } = this.props

    if (this.messages.length > 1) {
      return false
    }

    return hideThreadIfNoMessages
  }

  public render() {
    const { photo, showImages, showFooterLine, FileInputType } = this.props

    return (
      <CommonThread
        isPhotoThread={true}
        showImages={showImages}
        hideThread={this.hideThread}
        showFooterLine={showFooterLine}
        messages={this.messages}
        threadIcon={
          <CameraIcon
            size={16}
            className="tw:inline tw:text-muted-foreground"
          />
        }
        threadClass={'photo-thread'}
        caption=""
        model={photo}
        FileInputType={FileInputType}
      />
    )
  }
}

export default CommentsList
